import React, { useEffect,useRef, useState } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import './AddNewBusiness.css';
import BusinessSidebar from "../../BusinessSidebar";
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";

import { Link } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Multiselect from "multiselect-react-dropdown"; 
import API from '../../../Utils/Api';
import {validatebusiness} from '../../../Utils/validate';
import loader from '../../../assests/loader.gif';
import { gettoastwarning,gettoastsuccess } from '../../../Utils/Common';
import Modal from 'react-bootstrap/Modal';
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../BusinessMyDeal/firebase";
import {validateforotp} from '../../../Utils/validate';

//import { LoadScript, Autocomplete } from "@react-google-maps/api";

const AddNewBusiness = () => {

//const [autocomplete, setAutocomplete] = useState(null);

const [loading,setLoading] = useState(false);
    const [errors,setErrors] = useState({});
    const [inputs,setInputs] = useState({business_name:'',email:'',contact_number:'',address:'',business_description:'',pincode:'',state:'',city:'',town:'',category_id:'',latitude:'',longitude:''});

 const [otpstatus, setOtpstatus] = useState(0);


    const [state, setState] = useState([]);
const [city, setCity] = useState([]);
const [town, setTown] = useState([]);
    const [category, setCategory] = useState([]);


const [otp, setOtp] = useState(new Array(6).fill(''));
    const inputRefs = useRef([]);
const [show2, setShow2] = useState(false);
const handleClose2 = () => setShow2(false);

    useEffect(() => {
        document.title = `Add New Business | Local Bells`;
        document.getElementById('bodywrap').className = 'busiaddnewbusi';

        API.post('get_state')
          .then(response => {
          setState(response.data.data);       
          });

          API.post('get_categories')
              .then(response => {
              setCategory(response.data.data);       
          });

    }, []);

    // State to toggle sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    // Function to toggle sidebar visibility
    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };



const getCity = (event) => {     
      event.preventDefault();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 

      setTown([]);  

      var st='city';
      var st_val='';
       setInputs(inputs => ({...inputs, [st]: st_val})); 

       var ct='town';
      var ct_val='';
       setInputs(inputs => ({...inputs, [ct]: ct_val})); 

      let formData = new FormData(); 
          formData.append('state_id', event.target.value);
          API.post('get_city', formData)
                    .then(response => {
                      
                    if(response.data.status === true){
                     setCity(response.data.data);  
                    }else{
                        
                         
                    }
                  }).catch(error => {
                      
              }); 
  }

  const getTown = (event) => {     
      event.preventDefault();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 

      setTown([]);  

       var ct='town';
      var ct_val='';
       setInputs(inputs => ({...inputs, [ct]: ct_val})); 

      let formData = new FormData(); 
          formData.append('city_id', event.target.value);
          API.post('get_town', formData)
                    .then(response => {
                      
                    if(response.data.status === true){
                     setTown(response.data.data);  
                      var ct1 = 'town';
                      var ct_val1 = response.data.extra_data.town_id;
                      setInputs(inputs => ({ ...inputs, [ct1]: ct_val1 }));

                      var pin1 = 'pincode';
                      var pin_val1 = response.data.extra_data.pincode;
                      setInputs(inputs => ({ ...inputs, [pin1]: pin_val1 }));
                    }else{
                        
                         
                    }
                  }).catch(error => {
                      
              }); 

  }


    //const value = 65;

	const handleSubmit = (e) => {
		e.preventDefault();

        const validationErrors = validatebusiness(inputs);
        const noErrors = Object.keys(validationErrors).length === 0;
        setErrors({});
        setErrors(validationErrors);
        
        if(noErrors){
            setLoading(true);
            let formData = new FormData(); 
            Object.keys(inputs).forEach((key) => {
                if (key === 'category_id') {
                    formData.append('categories', inputs.category_id.join(','));
                  } else {
                    formData.append(key, inputs[key]);
                }
            });
            formData.append('is_phone_verified', otpstatus);
            
            API.post('add_business_with_business_login', formData)
              .then(response => {
              if(response.data.status === false){
                //setError(response.data.message);
                setLoading(false); 
                gettoastwarning(response.data.message,'');
              }else{
                 setLoading(false);

                 localStorage.setItem("business_id", response.data.data.business_id);

                 gettoastsuccess(response.data.message,'/business/my-deal');
              }                  
            }).catch(error => {
               setLoading(false);
               gettoastwarning("Something went wrong. Please try again later.",'');
            });
        }
	};
    
    /* Start Value set */
const handleInputChange = (event) => {
  event.persist();
  setInputs(inputs => ({...inputs, [event.target.name]: event.target.value}));       
}
const handleInputChangeMo = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only numbers (0–9)
  const regex = /^[0-9]*$/;

  if (regex.test(value)) {
    setInputs(inputs => ({ ...inputs, [name]: value }));
    //getpicode_town(value);
  }      
}
const handleInputChangeMob = (event) => {
  event.persist();
  const { name, value } = event.target;

  // Allow only numbers (0–9)
  const regex = /^[0-9]*$/;

  if (regex.test(value)) {
    setOtpstatus(0);
    setInputs(inputs => ({ ...inputs, [name]: value }));
    //getpicode_town(value);
  }      
}
/* End Value set */
const handleCategorySelect = (selectedList) => {
    const ids = selectedList.map(lang => lang.id);
    setInputs(prev => ({ ...prev, category_id: ids }));
    setTimeout(() => {
        document.querySelector(".custom-multiselect input")?.blur();
      }, 50);
};

  const handleCategoryRemove = (selectedList) => {
    const ids = selectedList.map(lang => lang.id);
    setInputs(prev => ({ ...prev, category_id: ids }));
  };
  const getCat = (event) => {     
      event.preventDefault();
      setInputs(inputs => ({...inputs, [event.target.name]: event.target.value})); 
      get_town_picode(event.target.value);
  }
const get_town_picode = (id) => {
        let formData = new FormData(); 
         formData.append('town_id', id);
        API.post('get_town_pincode',formData)
            .then(response => {
              
            if(response.data.status === true){
                if(response.data.data.city_id!=='')
                {
                    var pincode_label='pincode';
                    var pincode_val=response.data.data.pincode;
                    setInputs(inputs => ({...inputs, [pincode_label]: pincode_val}));
                }
            }else{
                    
            }
          }).catch(error => {
              
      });
}
const getpicode_town = () => {
      if(inputs.pincode!=='')
      {
            let formData = new FormData(); 
             formData.append('pin_code', inputs.pincode);
            API.post('get_pincode_town',formData)
                .then(response => {
                  
                if(response.data.status === true){
                    if(response.data.data.city_id!=='' && response.data.data.city_id!=='')
                    {
                        setCity(response.data.data.city);
                        setTown(response.data.data.town);
                        var state_label='state';
                        var state=response.data.data.state_id;
                        setInputs(inputs => ({...inputs, [state_label]: state}));

                        var city_label='city';
                        var city=response.data.data.city_id;
                        setInputs(inputs => ({...inputs, [city_label]: city}));

                        var town_label='town';
                        var town=response.data.data.town_id;
                        setInputs(inputs => ({...inputs, [town_label]: town}));

                        var town_text=response.data.data.town_name;
                        var town_name_lbl="town_name";
                        setInputs(inputs => ({ ...inputs, [town_name_lbl]: town_text }));
                    }else{
                        setCity([]);
                            setTown([]);
                            var state_label3 = 'state';
                            var state3 = '';
                            setInputs(inputs => ({ ...inputs, [state_label3]: state3 }));

                            var city_label3 = 'city';
                            var city3 = '';
                            setInputs(inputs => ({ ...inputs, [city_label3]: city3 }));

                            var town_label3 = 'town';
                            var town3 = '';
                            setInputs(inputs => ({ ...inputs, [town_label3]: town3 }));

                            var town_text3='';
                                var town_name_lbl3="town_name";
                                setInputs(inputs => ({ ...inputs, [town_name_lbl3]: town_text3 }));
                    }
                }else{
                    setCity([]);
                        setTown([]);
                        var state_label1 = 'state';
                        var state1 = '';
                        setInputs(inputs => ({ ...inputs, [state_label1]: state1 }));

                        var city_label1 = 'city';
                        var city1 = '';
                        setInputs(inputs => ({ ...inputs, [city_label1]: city1 }));

                        var town_label1 = 'town';
                        var town1 = '';
                        setInputs(inputs => ({ ...inputs, [town_label1]: town1 }));

                        var town_text1='';
                            var town_name_lbl1="town_name";
                            setInputs(inputs => ({ ...inputs, [town_name_lbl1]: town_text1 }));    
                }
              }).catch(error => {
                  
          });
      }else{
            setCity([]);
            setTown([]);
            var state_label2 = 'state';
            var state2 = '';
            setInputs(inputs => ({ ...inputs, [state_label2]: state2 }));

            var city_label2 = 'city';
            var city2 = '';
            setInputs(inputs => ({ ...inputs, [city_label2]: city2 }));

            var town_label2 = 'town';
            var town2 = '';
            setInputs(inputs => ({ ...inputs, [town_label2]: town2 }));

            var town_text2='';
            var town_name_lbl2="town_name";
            setInputs(inputs => ({ ...inputs, [town_name_lbl2]: town_text2 }));
      }
}

const sendOtp = () => {
    if(inputs.contact_number){
     setLoading(true);
  const container = document.getElementById("recaptcha-container");
  if (!container) {
    console.error("reCAPTCHA container missing");
    setLoading(false);
    return;
  }

  if (!window.recaptchaVerifier) {
    window.recaptchaVerifier = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      { size: "invisible" }
    );
  }

  const phoneNumber = "+91"+inputs.contact_number;
  const appVerifier = window.recaptchaVerifier;

  signInWithPhoneNumber(auth, phoneNumber, appVerifier)
    .then((confirmationResult) => {
      window.confirmationResult = confirmationResult;
      //alert("OTP Sent");
        setLoading(false);
        setShow2(true);
    })
    .catch((error) => {
        setLoading(false);
        let errorMessage = 'Something went wrong. Please try again.';
        switch (error.code) {
            case 'auth/invalid-phone-number':
                errorMessage = 'Invalid phone number. Please enter a valid number.';
                break;
            case 'auth/quota-exceeded':
                errorMessage = 'Too many requests. Please try again later.';
                break;
            case 'auth/user-disabled':
                errorMessage = 'This user has been disabled. Contact support.';
                break;
            case 'auth/too-many-requests':
                errorMessage = 'Too many attempts. Please wait before retrying.';
                break;
            default:
                errorMessage = error.message; // Firebase provides specific messages
                break;
        }
        gettoastwarning(errorMessage, '');
      //console.error(error);
      //alert(error.message);
    });
 }
 }
const handleChange = (element, index) => {
        const value = element.value.replace(/[^0-9]/g, ''); // Only digits
        if (value) {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            // Move to next input
            if (index < 5) {
                inputRefs.current[index + 1].focus();
            }
        }
    };
    const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace') {
            if (otp[index] === '') {
                if (index > 0) {
                    inputRefs.current[index - 1].focus();
                }
            } else {
                const newOtp = [...otp];
                newOtp[index] = '';
                setOtp(newOtp);
            }
        }
    };
    const verifyOtp = () => {
    setLoading(true);
   const validationErrors = validateforotp(otp);
  const noErrors = Object.keys(validationErrors).length === 0;
  setErrors(validationErrors);
  if(noErrors){
    var ot='';
    otp.forEach((item, index) => {
      ot+=item;
    })
      window.confirmationResult.confirm(ot)
        .then((result) => {
            setLoading(false);
            setShow2(false);
          //console.log("User:", result.user);
          //alert("OTP Verified");
            gettoastsuccess("Mobile number verified successfully", "");
            setOtpstatus(1);
        })
        .catch(() => {
            setLoading(false);
            gettoastwarning("Invalid OTP. Please enter the correct OTP.", "");
        });
    }
};
/*const onLoad = (auto) => setAutocomplete(auto);

  const onPlaceChanged = () => {
    if (!autocomplete) return;

    const place = autocomplete.getPlace();

    var albl = 'address';
    setInputs(inputs => ({ ...inputs, [albl]: place.formatted_address }));
    
    if (place.geometry && place.geometry.location) {

        var latlbl = 'latitude';
        setInputs(inputs => ({ ...inputs, [latlbl]: place.geometry.location.lat() }));

        var longlbl = 'longitude';
        setInputs(inputs => ({ ...inputs, [longlbl]: place.geometry.location.lng() }));

      
    }

  };

  const handleChange = (e) => {
    setInputs((prev) => ({
      ...prev,
      address: e.target.value,
    }));
  };*/

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />
                            <div className='nei-cont'>
                                <div className='white-box business-form'>
                                    <Row className='mb-3'>
                                        <Col md={12} lg={12} xl={5}>
                                            <h3>Add New Business</h3>
                                        </Col>
                                        <Col md={12} lg={12} xl={7}>
                                            <div className='bf-right float-end'>
                                                {/*<div>
                                                    <ProgressBar value={value} />
                                                    <h6 className='fw-600 text-uppercase'>{value}% Competed</h6>
                                                </div>*/}
                                                <Link to="/business/new-deal" className='add-link'>+ Add Discount Deals</Link>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Form onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md={12} lg={12} xl={5}>
                                                {/*<Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>First Name</Form.Label>
                                                    <Form.Control type="text" placeholder="First Name" name="first_name" onChange={handleInputChange} value={inputs.first_name} />
                                                </Form.Group>
                                                {errors.first_name && (<p className="text-danger">{errors.first_name}</p>)}
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Last Name</Form.Label>
                                                    <Form.Control type="text" placeholder="Last Name" name="last_name" onChange={handleInputChange} value={inputs.last_name} />
                                                </Form.Group>
                                                {errors.last_name && (<p className="text-danger">{errors.last_name}</p>)}*/}
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Business Name</Form.Label>
                                                    <Form.Control type="text" placeholder="Business Name" name="business_name" onChange={handleInputChange} value={inputs.business_name} />
                                                </Form.Group>
                                                {errors.business_name && (<p className="text-danger">{errors.business_name}</p>)}
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Business Email</Form.Label>
                                                    <Form.Control type="text" placeholder="Business Email" name="email" onChange={handleInputChange} value={inputs.email} />
                                                </Form.Group>
                                                {errors.email && (<p className="text-danger">{errors.email}</p>)}
                                                <InputGroup className="anb-cont mb-3">
                                                    <Form.Control
                                                        placeholder="Business Contact number"
                                                        aria-label="cntno"
                                                        aria-describedby="cntno"
                                                        type="text"
                                                        name="contact_number" onChange={handleInputChangeMob} value={inputs.contact_number}
                                                        maxLength={15}
                                                    />
                                                    <InputGroup.Text id="cntno" >
                                                        <Link to="#" onClick={sendOtp}>Verify phone number</Link>
                                                    </InputGroup.Text>
                                                </InputGroup>
                                                <div id="recaptcha-container"></div>
                                                {errors.contact_number && (<p className="text-danger">{errors.contact_number}</p>)}
                                                {/*<TagsInput />*/}

                                                
                                            </Col>
                                            <Col md={12} lg={12} xl={7}>

                                                {/*<Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Business Address</Form.Label>
                                                    <Form.Control as="textarea" rows={4} placeholder='Address' name="address" onChange={handleInputChange} value={inputs.address} />
                                                </Form.Group>
                                                {errors.address && (<p className="text-danger">{errors.address}</p>)}*/}
                                            <div className="mb-3">
                                                    <Form.Label className=''>Business Address</Form.Label>
                                                <Form.Control as="textarea" rows={3} placeholder='Address' name="address" onChange={handleInputChange} value={inputs.address} />
                                                {/*<LoadScript
                                                  googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                                                  libraries={["places"]}
                                                  version="weekly"
                                                >
                                                  <Autocomplete
                                                    onLoad={onLoad}
                                                    onPlaceChanged={onPlaceChanged}
                                                    options={{
                                                      types: ["geocode"],
                                                      componentRestrictions: { country: "in" }
                                                    }}
                                                  >
                                                    <input
                                                      type="text"
                                                      placeholder="Enter address"
                                                      className="form-control"
                                                      value={inputs.address}
                                                      onChange={handleChange}
                                                    />
                                                  </Autocomplete>
                                                </LoadScript>*/}
                                                {errors.address && (<p className="text-danger">{errors.address}</p>)}
                                            </div>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className='d-none'>Pin code</Form.Label>
                                                    <Form.Control type="text" placeholder="Pin code" name="pincode" onChange={handleInputChangeMo} onBlur={getpicode_town} value={inputs.pincode} maxLength={6} />
                                                </Form.Group>
                                                {errors.pincode && (<p className="text-danger">{errors.pincode}</p>)}
                                                
                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example" name="state" onChange={getCity} value={inputs.state}>
                                                            <option value="">State</option>
                                                        {state && state.map((val, index) => {
                                                           return (
                                                                                                <option value={val.id}>{val.name}</option>
                                                                                            )
                                                         })}
                                                        </Form.Select>
                                                        {errors.state && (<p className="text-danger">{errors.state}</p>)}
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example" name="city" onChange={getTown} value={inputs.city}>
                                                            <option value="">City</option>
                                                            {city && city.map((val, index) => {
                                       return (
                                                                        <option value={val.id}>{val.name}</option>
                                                                    )
                          })}
                                                        </Form.Select>
                                                        {errors.city && (<p className="text-danger">{errors.city}</p>)} 
                                                    </Col>
                                                    <Col md={4}>
                                                        <Form.Select aria-label="Default select example" name="town" onChange={getCat} value={inputs.town}>
                                                           <option value="">Locality</option>
                                                            {town && town.map((val, index) => {
                                           return ( 
                                                                        <option value={val.id}>{val.name}</option>
                                                                     )
                                                                })}
                                                        </Form.Select>
                                                        {errors.town && (<p className="text-danger">{errors.town}</p>)}
                                                    </Col>
                                                </Row>
                                                <div className="position-relative">
                                                    <div className="multi-drop-box">
                                                        X
                                                    </div>
                                                <Multiselect
                                                      options={category}
                                                     selectedValues={category.filter(lang => inputs.category_id.includes(lang.id))}
                                                      onSelect={handleCategorySelect}
                                                      onRemove={handleCategoryRemove}
                                                      placeholder="Select Category"
                                                      className="custom-multiselect"
                                                      displayValue="name"
                                                      showArrow={false}
                                                    />
                                                </div>
                                                {errors.category_id && (<p className="text-danger">{errors.category_id}</p>)}
                                                <div className='yellow-note'>
                                                    <h6>Tag upto 10 categories. Your business will be shown in search when users search for business with one of your selected categories</h6>
                                                </div>
                                                <Button variant="primary" type="submit" className='orange-btn'>
                                                    <h6>Launch Business</h6>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                                <div className='footer-org footer'>
                                    <Footer />                                
                                </div>                                  
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Modal
                size="md"
                show={show2}
                onHide={handleClose2}
                backdrop="static"
                keyboard={false}
                centered
                className="new-modal otp-modal"
                >
                <Modal.Header className="border-0 pb-0">
                    <h5 className="modal-title">OTP Verification</h5>
                </Modal.Header>
 
                <Modal.Body>
                    <p className="mb-3">
                    Please enter the 6 digit OTP sent to your mobile number
                    </p>
 
                    <Form>
                    <div className="d-flex justify-content-between otp-box-wrapper mb-4">
                        {[...Array(6)].map((_, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                inputMode="numeric"
                                pattern="[0-9]*"
                                className="otp-box"
                                onChange={(e) => handleChange(e.target, index)}
                                onKeyDown={(e) => handleKeyDown(e, index)}
                                ref={(el) => (inputRefs.current[index] = el)}
                            />
                        ))}
                    </div>
                    {errors.otp && (<p className="text-danger text-start mb-1">{errors.otp}</p>)}
                    <div className="d-flex justify-content-end gap-3">
                        <Button className='sub-close' onClick={handleClose2}>
                        Cancel
                        </Button>
                        <Button className='btn sub-submit' onClick={verifyOtp}>
                        Verify OTP
                        </Button>
                    </div>
                    </Form>
                </Modal.Body>
            </Modal>
            {loading && (
           <div className="loadingClass">
            <img src={loader} alt="loader"/>
          </div>
           )} 
        </>
    )
}

export default AddNewBusiness;


